import React, { useState } from "react";
import "./AddReminderModal.css"; // Nayi unique CSS file

const AddReminderModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    start: "",
    period: "",
    date: ""
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <div className="arm-modal-overlay">
      <div className="arm-modal-content">

        <div className="arm-modal-header">
          <h3>Add Reminder</h3>
          <button className="arm-close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="arm-modal-body">

          <div className="arm-form-grid-3">
            <div className="arm-form-group">
              <label>Name *</label>
              <input 
                name="name" 
                className="arm-form-control" 
                onChange={handleChange} 
                placeholder="Reminder name"
              />
            </div>

            <div className="arm-form-group">
              <label>Type *</label>
              <input 
                name="type" 
                className="arm-form-control" 
                onChange={handleChange} 
                placeholder="e.g. Service"
              />
            </div>

            <div className="arm-form-group">
              <label>Start</label>
              <input 
                name="start" 
                className="arm-form-control" 
                onChange={handleChange} 
                placeholder="Start value"
              />
            </div>
          </div>

          <div className="arm-form-grid-2">
            <div className="arm-form-group">
              <label>Period</label>
              <input 
                name="period" 
                className="arm-form-control" 
                onChange={handleChange} 
                placeholder="e.g. 6 Months"
              />
            </div>

            <div className="arm-form-group">
              <label>Date *</label>
              <input 
                type="date" 
                name="date" 
                className="arm-form-control" 
                onChange={handleChange} 
              />
            </div>
          </div>

        </div>

        <div className="arm-modal-footer">
          <button className="arm-btn arm-btn-submit" onClick={() => onSubmit(formData)}>
            SUBMIT
          </button>
          <button className="arm-btn arm-btn-cancel" onClick={onClose}>
            CANCEL
          </button>
        </div>

      </div>
    </div>
  );
};

export default AddReminderModal;